import type { SEOHandle } from "@nasa-gcn/remix-seo";
import type { MetaFunction } from "@remix-run/node";

import LegalPage from "~/components/legal/LegalPage";
import generateSitemapEntriesFor from "~/helpers/sitemapEntriesWithLocal";
import legal from "~/i18n/legal";
import { useT } from "~/i18n/useT";
import { buildMeta, langFromParams } from "~/seo/meta";

export const meta: MetaFunction = ({ params }) => {
  const lang = langFromParams(params);
  const t = legal[lang].privacy;

  return buildMeta({
    lang,
    path: "/privacy",
    title: t.metaTitle,
    description: t.metaDescription,
  });
};

export const handle: SEOHandle = generateSitemapEntriesFor(
  "/privacy",
  undefined,
  "yearly",
  0.3,
);

export default function PrivacyPage() {
  const t = useT(legal).privacy;
  return <LegalPage title={t.title} sections={t.sections} />;
}
